<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <header-padrao class="mb-2" icon="fa fa-warehouse" titulo="CADASTRO DE CENTRO DE ESTOQUE">
        <template #subtitulo>
          <div class="d-flex align-items-center flex-wrap">
            <span class="mr-2">
              <i class="fa fa-key mr-1 text-info"></i>
              Código: <strong class="text-white">{{formulario.CODIGO || 'Novo'}}</strong>
            </span>
            <span v-if="formulario.DESCRICAO" class="mx-2">•</span>
            <span v-if="formulario.DESCRICAO" class="mr-2">
              {{formulario.DESCRICAO.substring(0,50)}}
            </span>
          </div>
        </template>

        <template #acoes>
          <b-button variant="link" class="btn-glass btn-glass-success px-4 font-weight-bold" @click.stop.prevent="salvar()" :disabled="!formularioValido || salvando">
            <i class="fa fa-save mr-1"></i> {{ salvando ? 'SALVANDO...' : 'GRAVAR' }}
          </b-button>

          <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop.prevent="voltar()" :disabled="salvando">
            <i class="fa fa-arrow-left mr-1"></i> Voltar
          </b-button>
        </template>
      </header-padrao>

      <b-row class="px-2">
        <b-col sm="12">
          <!-- Dados Principais -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-info-circle"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Informações Principais</h6>
                  <small class="text-muted">Dados do centro de estoque</small>
                </div>
              </div>
            </template>

            <b-row class="mb-3">
              <b-col sm="9">
                <label class="modal-label-premium">Descrição *</label>
                <b-form-input 
                  type="text" 
                  v-model="formulario.DESCRICAO" 
                  maxlength="30" 
                  class="rounded-pill shadow-xs"
                  :class="{'is-invalid': !formulario.DESCRICAO}"
                  placeholder="Informe a descrição do centro de estoque"
                  ref="edDescricao">
                </b-form-input>
              </b-col>
              
              <b-col sm="3">
                <label class="modal-label-premium">Situação *</label>
                <b-form-select 
                  v-model="formulario.OP_SITUACAO" 
                  class="rounded-pill shadow-xs"
                  :class="{'is-invalid': !formulario.OP_SITUACAO}">
                  <b-form-select-option value="1">Ativo</b-form-select-option>
                  <b-form-select-option value="0">Inativo</b-form-select-option>
                </b-form-select>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col sm="12">
                <label class="modal-label-premium">Tipo *</label>
                <b-form-select 
                  v-model="formulario.TIPO" 
                  class="rounded-pill shadow-xs"
                  :class="{'is-invalid': !formulario.TIPO}">
                  <b-form-select-option :value="null">Selecione o tipo...</b-form-select-option>
                  <b-form-select-option value="1">Tipo 1</b-form-select-option>
                  <b-form-select-option value="2">Tipo 2</b-form-select-option>
                  <b-form-select-option value="3">Almoxarifado</b-form-select-option>
                </b-form-select>
              </b-col>
            </b-row>
          </b-card>

          <!-- Opções Operacionais -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-warning text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-cog"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Opções Operacionais</h6>
                  <small class="text-muted" v-if="!modoEdicao">Configurações iniciais (não podem ser alteradas após criação)</small>
                  <small class="text-danger" v-else>* Campos bloqueados após criação</small>
                </div>
              </div>
            </template>

            <b-row>
              <b-col sm="4" class="mb-3">
                <label class="modal-label-premium">Recebe Transferência</label>
                <b-form-select 
                  v-model="formulario.OP_RECEBE_TRANSFERENCIA" 
                  class="rounded-pill shadow-xs"
                  :disabled="modoEdicao">
                  <b-form-select-option value="1">Sim</b-form-select-option>
                  <b-form-select-option value="0">Não</b-form-select-option>
                </b-form-select>
              </b-col>

              <b-col sm="4" class="mb-3">
                <label class="modal-label-premium">Permite Venda</label>
                <b-form-select 
                  v-model="formulario.OP_PERMITE_VENDA" 
                  class="rounded-pill shadow-xs"
                  :disabled="modoEdicao">
                  <b-form-select-option value="1">Sim</b-form-select-option>
                  <b-form-select-option value="0">Não</b-form-select-option>
                </b-form-select>
              </b-col>

              <b-col sm="4" class="mb-3">
                <label class="modal-label-premium">Recebe Banda</label>
                <b-form-select 
                  v-model="formulario.OP_RECEBE_BANDA" 
                  class="rounded-pill shadow-xs"
                  :disabled="modoEdicao">
                  <b-form-select-option value="1">Sim</b-form-select-option>
                  <b-form-select-option value="0">Não</b-form-select-option>
                </b-form-select>
              </b-col>
            </b-row>

            <b-alert v-if="modoEdicao" show variant="info" class="mt-2 mb-0">
              <i class="fa fa-info-circle mr-2"></i>
              <strong>Atenção:</strong> As opções operacionais acima não podem ser alteradas após a criação do centro de estoque por questões de integridade do sistema.
            </b-alert>
          </b-card>

          <!-- Dados de Auditoria (apenas no modo edição) -->
          <b-card v-if="modoEdicao" class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-info text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-clock-o"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Informações de Auditoria</h6>
                  <small class="text-muted">Dados de criação e alteração</small>
                </div>
              </div>
            </template>

            <b-row>
              <b-col sm="6" class="mb-3">
                <label class="modal-label-premium">Data de Cadastro</label>
                <b-form-input 
                  type="text" 
                  :value="formatarDataHora(formulario.DT_CADASTRO)" 
                  disabled
                  class="rounded-pill shadow-xs campo-desabilitado">
                </b-form-input>
              </b-col>

              <b-col sm="6" class="mb-3">
                <label class="modal-label-premium">Usuário de Cadastro</label>
                <b-form-input 
                  type="text" 
                  v-model="formulario.USUARIO_CADASTRO" 
                  disabled
                  class="rounded-pill shadow-xs campo-desabilitado">
                </b-form-input>
              </b-col>

              <b-col sm="6" class="mb-3">
                <label class="modal-label-premium">Data de Alteração</label>
                <b-form-input 
                  type="text" 
                  :value="formatarDataHora(formulario.DT_ALTERACAO)" 
                  disabled
                  class="rounded-pill shadow-xs campo-desabilitado">
                </b-form-input>
              </b-col>

              <b-col sm="6" class="mb-3">
                <label class="modal-label-premium">Usuário de Alteração</label>
                <b-form-input 
                  type="text" 
                  v-model="formulario.USUARIO_ALTERACAO" 
                  disabled
                  class="rounded-pill shadow-xs campo-desabilitado">
                </b-form-input>
              </b-col>
            </b-row>
          </b-card>

        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import moment from 'moment'

export default {
  name: 'CentroEstoqueCadastro',
  components: {
    HeaderPadrao
  },
  data () {
    return {
      formulario: {
        CODIGO: null,
        DESCRICAO: '',
        TIPO: null,
        OP_SITUACAO: '1',
        OP_RECEBE_TRANSFERENCIA: '0',
        OP_PERMITE_VENDA: '0',
        OP_RECEBE_BANDA: '0',
        DT_CADASTRO: null,
        USUARIO_CADASTRO: '',
        DT_ALTERACAO: null,
        USUARIO_ALTERACAO: ''
      },
      salvando: false,
      modoEdicao: false
    }
  },
  computed: {
    isDark() {
      return this.$store.getters['tema/IS_DARK']
    },
    formularioValido () {
      return this.formulario.DESCRICAO && 
             this.formulario.DESCRICAO.trim().length > 0 &&
             this.formulario.TIPO &&
             this.formulario.OP_SITUACAO
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.modoEdicao = true
      this.carregarDados()
    } else {
      this.$nextTick(() => {
        if (this.$refs.edDescricao) {
          this.$refs.edDescricao.focus()
        }
      })
    }
  },
  methods: {
    carregarDados () {
      this.$http.get(`/api/protected/centroEstoque/getById/${this.$route.params.id}`)
        .then(response => {
          if (response.data && response.data.length > 0) {
            this.formulario = response.data[0]
          } else {
            this.$bvToast.toast('Centro de estoque não encontrado', { title: 'Erro', variant: 'danger' })
            this.voltar()
          }
        })
        .catch(error => {
          console.error('Erro ao carregar centro de estoque:', error)
          this.$bvToast.toast('Erro ao carregar dados', { title: 'Erro', variant: 'danger' })
          this.voltar()
        })
    },
    
    salvar () {
      if (!this.formularioValido) {
        this.$bvToast.toast('Preencha todos os campos obrigatórios', { title: 'Atenção', variant: 'warning' })
        return
      }

      this.salvando = true
      this.$store.commit('controle/setAguardando', true)

      const rota = this.modoEdicao
        ? '/api/protected/centroEstoque/edit'
        : '/api/protected/centroEstoque/post'

      // Prepara o payload conforme padrão do backend (com registro)
      const payload = {
        registro: this.formulario,
        login: window.localStorage.getItem('login') || ''
      }

      this.$http.post(rota, payload)
        .then(response => {
          this.$bvToast.toast(
            this.modoEdicao
              ? 'Centro de estoque atualizado com sucesso!'
              : 'Centro de estoque cadastrado com sucesso!',
            { title: 'Sucesso', variant: 'success' }
          )
          this.$store.commit('centroEstoque/SET_RECARREGAR_LISTA', true)
          this.voltar()
        })
        .catch(error => {
          console.error('Erro ao salvar centro de estoque:', error)
          this.$bvToast.toast('Erro ao salvar registro', { title: 'Erro', variant: 'danger' })
        })
        .finally(() => {
          this.salvando = false
          this.$store.commit('controle/setAguardando', false)
        })
    },
    
    voltar () {
      this.$router.push({ name: 'CentroEstoqueListagem' })
    },
    
    formatarDataHora(data) {
      if (!data) return ''
      return moment(data).format('DD/MM/YYYY HH:mm:ss')
    }
  }
}
</script>

<style lang="scss" scoped>
.campo-desabilitado {
  background-color: #e9ecef !important;
  opacity: 0.7;
}

.modal-label-premium {
  font-weight: 600;
  font-size: 0.9rem;
  color: #495057;
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/estoque/centro-estoque/CentroEstoqueCadastro.vue